// Buffer polyfill for @solana/web3.js (lazy-loaded on the Solana money path).
// Browsers/Vite don't ship Node's Buffer and web3.js needs it for (de)serialization.
import {Buffer} from 'buffer';
if (typeof globalThis.Buffer === 'undefined') globalThis.Buffer = Buffer;

// Sentry must initialise BEFORE the React tree mounts so the error
// boundary it provides sees a configured client.
import {initSentry, SentryErrorBoundary} from './sentry';
initSentry();

import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import {PrivyProvider} from './auth/PrivyProvider';
import './index.css';

// Visual fallback rendered when a React error escapes the tree. Keep it
// plain — the surrounding chrome may itself be broken. Sentry already
// captured the exception by the time we get here.
function CrashFallback() {
  return (
    <div style={{
      padding: 32,
      color: '#fff',
      background: '#05070b',
      fontFamily: 'system-ui',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
    }}>
      <div style={{fontSize: 22, fontWeight: 700, color: '#fbbf24'}}>
        Something went wrong
      </div>
      <div style={{maxWidth: 420, opacity: 0.85, textAlign: 'center'}}>
        We've been notified and are looking into it. Try reloading the page.
      </div>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 20px',
          borderRadius: 10,
          border: 0,
          background: '#5b8cff',
          color: '#fff',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<CrashFallback />}>
      <PrivyProvider>
        <App />
      </PrivyProvider>
    </SentryErrorBoundary>
  </StrictMode>,
);
